/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_ExampleInputs */

const en_mk_tb_example = /** @type {(inputs: Mk_Tb_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative team board · example work, not live project data`)
};

const id_mk_tb_example = /** @type {(inputs: Mk_Tb_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustrasi papan tim · contoh pekerjaan, bukan data proyek aktif`)
};

/**
* | output |
* | --- |
* | "Illustrative team board · example work, not live project data" |
*
* @param {Mk_Tb_ExampleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example = /** @type {((inputs?: Mk_Tb_ExampleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_ExampleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example(inputs)
	return en_mk_tb_example(inputs)
});